import { render, staticRenderFns } from "./DetailSummary.vue?vue&type=template&id=5108a0b1&scoped=true"
import script from "./DetailSummary.vue?vue&type=script&lang=js"
export * from "./DetailSummary.vue?vue&type=script&lang=js"
import style0 from "./DetailSummary.vue?vue&type=style&index=0&id=5108a0b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5108a0b1",
  null
  
)

export default component.exports